import styled from 'styled-components';
import { Flex, Headline, mediaQueries, theme } from '@lce/slice';

type TColors = keyof typeof theme.colors;
interface IPriceColor {
  color: TColors;
}

export const Price = styled(Flex)<IPriceColor>`
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
  color: ${({ color }) => theme.colors[ color as TColors ]};

  ${mediaQueries[1]} {
    margin-bottom: 0;
  }
`;

export const Dollars = styled(Headline).attrs({
  fontSize: ['11rem', '11rem', '12.25rem', '15.25rem'],
})`
  margin-bottom: 0;
  line-height: 0.6;
  color: inherit;
`;

export const Cents = styled(Headline).attrs({
  fontSize: ['5rem', '5rem', '5.5rem'],
})`
  margin-bottom: 0;
  line-height: 0.6;
  position: relative;
  color: inherit;
`;
